export default __webpack_public_path__ + "static/media/logo2.54d728b0.jpg";